import React from "react";
import severityConstants from '@a0/support-center-common/constants/tickets/customerSelectedSeverities';
import { TYPES_MAP } from '@a0/support-center-common/constants/tickets/types';

// Suboptions for ticket kind
const severities = [
  {
    key: severityConstants.LOW_SEVERITY,
    value: severityConstants.CUSTOMER_SELECTED_SEVERITIES[severityConstants.LOW_SEVERITY],
    text: "Low: Product question",
    subtext: "Minor Problem",
    description:
      "Information requested on Auth0 Platform capabilities, navigation, installation, or configuration."
  },
  {
    key: severityConstants.NORMAL_SEVERITY,
    value: severityConstants.CUSTOMER_SELECTED_SEVERITIES[severityConstants.NORMAL_SEVERITY],
    text: "Normal: General support issues",
    subtext: "Minor Feature / Function Issues / General Question",
    description:
      "Defect resulting in a component of the Auth0 Platform not performing as expected or documented or an inquiry by your representatives regarding general technical issues/questions."
  },
  {
    key: severityConstants.HIGH_SEVERITY,
    value: severityConstants.CUSTOMER_SELECTED_SEVERITIES[severityConstants.HIGH_SEVERITY],
    text: "High: Production application issue",
    subtext: "Significant Business Impact",
    description: (
      <React.Fragment>
        Defect resulting in a condition where major functionality is impacted or significant
        performance degradation is experienced;{" "}
        <mark>issue is persistent and affects many users and/or major functionality</mark>.
      </React.Fragment>
    )
  },
  {
    key: severityConstants.URGENT_SEVERITY,
    value: severityConstants.CUSTOMER_SELECTED_SEVERITIES[severityConstants.URGENT_SEVERITY],
    text: "Urgent: Production application offline",
    subtext: "Emergency Issue",
    description: (
      <React.Fragment>
        Defect resulting in full or partial system outage or a condition that makes the Auth0
        Platform unusable or unavailable in <mark>production for all of your users</mark>.
      </React.Fragment>
    )
  }
];



/** returns the additional questions that should be asked
 * depending on the specific ticket state (type, severity, and so on)
 */
export function getAdditionalQuestions(ticketState) {
  // additional questions are currently disabled.
  return [];
}

export function getAvailableSeverities(ticketState = {}) {
  const { type } = ticketState;
  const typeDef = type && TYPES_MAP[type];
  return typeDef && typeDef.severities || [];
}

export default {
  severities
};
